export default "__VITE_ASSET__BdQKyxjR__"